import Main from './Main'; // Import Main component

const AppLayout = () => {
  return (
    <Main/>
  );
}

export default AppLayout;
